import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep } from 'lodash';

import moIndex, { changeFreshCategoryYear } from '../../store/index';
import { newRate } from '@tool/index';
import HRService from '@service/hr';
// import { locateValue } from '@tool/index';

const moFresh = observable({
  type: 'chart', // chart, table
  tab: 'category', // category, time, city
  tableHead: <any[]>[],
  tableList: <any[]>[],
  cityTableHead: <any[]>[],
  cityTableList: <any[]>[],
  yearTableHead: <any[]>[],
  yearTableList: <any[]>[],
  isCity: false,
  chooseCity: <any[]>[],
  cityArr: <any[]>[],
  backupChoose: <any[]>[],
  backupCity: <any[]>[],
  xData: <any[]>[],
  yData: <any[]>[],
  overview: <any[]>[],
  labels: <any[]>[],
  cityXData: <any[]>[],
  cityYData: <any[]>[],
  cityOverview: <any[]>[],
  cityLabels: <any[]>[],
  yearXData: <any[]>[],
  yearYData: <any[]>[],
  yearOverview: <any[]>[],
  yearLabels: <any[]>[],
});

const locateValue = (value: any) => {
  if (isNaN(value)) return '-';
  if (value === null || value === '' || value === undefined) return '-';
  if (value === 0) return '-';
  return Number(value).toLocaleString();
};

const initCityList = action((res: any) => {
  // console.log('+++=== 城市应届生起薪 ===+++ ', res);
  let xData: any[] = [];
  let yData: any[] = [];
  let overview: any[] = [];
  let labels: any[] = [];
  let tableHead: any[] = [];
  let tableList: any[] = [];

  res.overview?.map((item: any) => {
    let text = '';
    item?.map((child: any) => {
      text += child.value;
    });
    overview.push(text);
  });

  // 大专 associate
  // 本科 bachelor
  // 硕士 master
  // 博士 doctor
  let associateArr: any[] = [];
  let bachelorArr: any[] = [];
  let masterArr: any[] = [];
  let doctorArr: any[] = [];

  // 大专
  res.data?.map((item: any) => {
    xData.push(item.city);
    associateArr.push(item.associate);
  });
  yData.push({ name: '大专', data: associateArr });

  // 本科
  res.data?.map((item: any) => {
    bachelorArr.push(item.bachelor);
  });
  yData.push({ name: '本科', data: bachelorArr });

  // 硕士
  res.data?.map((item: any) => {
    masterArr.push(item.master);
  });
  yData.push({ name: '硕士', data: masterArr });

  // 博士
  res.data?.map((item: any) => {
    doctorArr.push(item.doctor);
  });
  yData.push({ name: '博士', data: doctorArr });

  if (!isEmpty(res.total_city_data)) {
    if (res.total_city_data?.associate) {
      labels.push({
        value: res.total_city_data?.associate,
        text: `大专平均起薪`,
      });
    }
    if (res.total_city_data?.bachelor !== 0) {
      labels.push({
        value: res.total_city_data?.bachelor,
        text: `本科平均起薪`,
      });
    }
    if (res.total_city_data?.master !== 0) {
      labels.push({
        value: res.total_city_data?.master,
        text: `硕士平均起薪`,
      });
    }
    if (res.total_city_data?.doctor !== 0) {
      labels.push({
        value: res.total_city_data?.doctor,
        text: `博士平均起薪`,
      });
    }
  }

  tableHead = [
    { title: '城市' },
    {
      title: '大专',
      child: ['不区分'],
    },
    {
      title: '本科',
      child: ['不区分', '普通院校', '重点院校'],
    },
    {
      title: '硕士',
      child: ['不区分', '普通院校', '重点院校'],
    },
    {
      title: '博士',
      child: ['不区分', '普通院校', '重点院校'],
    },
  ];

  res.data?.map((item: any) => {
    let tempArr: any = [];
    xData.map((child: any) => {
      if (item.city === child) {
        tempArr.push(locateValue(item.associate));
        tempArr.push(locateValue(item.bachelor));
        tempArr.push(locateValue(item.bachelor_common));
        tempArr.push(locateValue(item.bachelor_key));
        tempArr.push(locateValue(item.master));
        tempArr.push(locateValue(item.master_common));
        tempArr.push(locateValue(item.master_key));
        tempArr.push(locateValue(item.doctor));
        tempArr.push(locateValue(item.doctor_common));
        tempArr.push(locateValue(item.doctor_key));
      }
    });
    tableList.push({
      title: item.city,
      arr: tempArr,
    });
  });

  moFresh.cityXData = xData;
  moFresh.cityYData = yData;
  moFresh.cityOverview = overview;
  moFresh.cityLabels = labels;
  moFresh.cityTableHead = tableHead;
  moFresh.cityTableList = tableList;
});

const initCategoryList = action((res: any) => {
  if (isEmpty(res)) return;

  // console.log('+++=== 职能应届生起薪 ===+++ ', res);
  let xData: any[] = [];
  let yData: any[] = [];
  let overview: any[] = [];
  let labels: any[] = [];
  let tableHead: any[] = [];
  let tableList: any[] = [];

  res.overview?.map((item: any) => {
    let text = '';
    item?.map((child: any) => {
      text += child.value;
    });
    overview.push(text);
  });

  // 大专 associate
  // 本科 bachelor
  // 硕士 master
  // 博士 doctor
  let associateArr: any[] = [];
  let bachelorArr: any[] = [];
  let masterArr: any[] = [];
  let doctorArr: any[] = [];

  // 大专
  res.data?.map((item: any) => {
    xData.push(item.category);
    associateArr.push(item.associate);
  });
  yData.push({ name: '大专', data: associateArr });

  // 本科
  res.data?.map((item: any) => {
    bachelorArr.push(item.bachelor);
  });
  yData.push({ name: '本科', data: bachelorArr });

  // 硕士
  res.data?.map((item: any) => {
    masterArr.push(item.master);
  });
  yData.push({ name: '硕士', data: masterArr });

  // 博士
  res.data?.map((item: any) => {
    doctorArr.push(item.doctor);
  });
  yData.push({ name: '博士', data: doctorArr });

  if (!isEmpty(res.total_category_data)) {
    if (res.total_category_data?.associate !== 0) {
      labels.push({
        value: res.total_category_data?.associate,
        text: `大专平均起薪`,
      });
    }
    if (res.total_category_data?.bachelor !== 0) {
      labels.push({
        value: res.total_category_data?.bachelor,
        text: `本科平均起薪`,
      });
    }
    if (res.total_category_data?.master !== 0) {
      labels.push({
        value: res.total_category_data?.master,
        text: `硕士平均起薪`,
      });
    }
    if (res.total_category_data?.doctor !== 0) {
      labels.push({
        value: res.total_category_data?.doctor,
        text: `博士平均起薪`,
      });
    }
  }

  tableHead = [
    { title: '职能类型' },
    {
      title: '大专',
      child: ['不区分'],
    },
    {
      title: '本科',
      child: ['不区分', '普通院校', '重点院校'],
    },
    {
      title: '硕士',
      child: ['不区分', '普通院校', '重点院校'],
    },
    {
      title: '博士',
      child: ['不区分', '普通院校', '重点院校'],
    },
  ];

  res.data?.map((item: any) => {
    let tempArr: any = [];
    xData.map((child: any) => {
      if (item.category === child) {
        tempArr.push(locateValue(item.associate));
        tempArr.push(locateValue(item.bachelor));
        tempArr.push(locateValue(item.bachelor_common));
        tempArr.push(locateValue(item.bachelor_key));
        tempArr.push(locateValue(item.master));
        tempArr.push(locateValue(item.master_common));
        tempArr.push(locateValue(item.master_key));
        tempArr.push(locateValue(item.doctor));
        tempArr.push(locateValue(item.doctor_common));
        tempArr.push(locateValue(item.doctor_key));
      }
    });
    tableList.push({
      title: item.category,
      arr: tempArr,
    });
  });

  moFresh.xData = xData;
  moFresh.yData = yData;
  moFresh.overview = overview;
  moFresh.labels = labels;
  moFresh.tableHead = tableHead;
  moFresh.tableList = tableList;
});

const initYearList = action((res: any) => {
  // console.log('+++=== 年度应届生起薪 ===+++ ', res);

  if (isEmpty(res)) return;

  let xData: any[] = [];
  let yData: any[] = [];
  let overview: any[] = [];
  let labels: any[] = [];
  let tableHead: any[] = [];
  let tableList: any[] = [];

  res.overview?.map((item: any) => {
    let text = '';
    item?.map((child: any) => {
      if (child.mark === 'change_rate') {
        text += newRate(child.value);
      } else {
        text += child.value;
      }
    });
    overview.push(text);
  });

  // 大专 associate
  // 本科 bachelor
  // 硕士 master
  // 博士 doctor
  let associateArr: any[] = [];
  let bachelorArr: any[] = [];
  let masterArr: any[] = [];
  let doctorArr: any[] = [];

  // 大专
  res.data?.map((item: any) => {
    xData.push(item.year);
    associateArr.push(item.associate);
  });
  yData.push({ name: '大专', data: associateArr });

  // 本科
  res.data?.map((item: any) => {
    bachelorArr.push(item.bachelor);
  });
  yData.push({ name: '本科', data: bachelorArr });

  // 硕士
  res.data?.map((item: any) => {
    masterArr.push(item.master);
  });
  yData.push({ name: '硕士', data: masterArr });

  // 博士
  res.data?.map((item: any) => {
    doctorArr.push(item.doctor);
  });
  yData.push({ name: '博士', data: doctorArr });

  res.data?.map((item: any) => {
    labels.push({
      value: item.avg_salary,
      text: `${item.year}届平均起薪`,
    });
  });

  // if (!isEmpty(res.total_year_data)) {
  //   if (res.total_year_data?.associate) {
  //     labels.push({
  //       value: res.total_year_data?.associate,
  //       text: `大专平均起薪`,
  //     });
  //   }
  //   if (res.total_year_data?.bachelor !== 0) {
  //     labels.push({
  //       value: res.total_year_data?.bachelor,
  //       text: `本科平均起薪`,
  //     });
  //   }
  //   if (res.total_year_data?.master !== 0) {
  //     labels.push({
  //       value: res.total_year_data?.master,
  //       text: `硕士平均起薪`,
  //     });
  //   }
  //   if (res.total_year_data?.doctor !== 0) {
  //     labels.push({
  //       value: res.total_year_data?.doctor,
  //       text: `博士平均起薪`,
  //     });
  //   }
  // }

  tableHead = [
    { title: '年份' },
    {
      title: '大专',
      child: ['不区分'],
    },
    {
      title: '本科',
      child: ['不区分', '普通院校', '重点院校'],
    },
    {
      title: '硕士',
      child: ['不区分', '普通院校', '重点院校'],
    },
    {
      title: '博士',
      child: ['不区分', '普通院校', '重点院校'],
    },
  ];

  res.data?.map((item: any) => {
    let tempArr: any = [];
    xData.map((child: any) => {
      if (item.year === child) {
        tempArr.push(locateValue(item.associate));
        tempArr.push(locateValue(item.bachelor));
        tempArr.push(locateValue(item.bachelor_common));
        tempArr.push(locateValue(item.bachelor_key));
        tempArr.push(locateValue(item.master));
        tempArr.push(locateValue(item.master_common));
        tempArr.push(locateValue(item.master_key));
        tempArr.push(locateValue(item.doctor));
        tempArr.push(locateValue(item.doctor_common));
        tempArr.push(locateValue(item.doctor_key));
      }
    });
    tableList.push({
      title: `${item.year}届`,
      arr: tempArr,
    });
  });

  moFresh.yearXData = xData;
  moFresh.yearYData = yData;
  moFresh.yearOverview = overview;
  moFresh.yearLabels = labels;
  moFresh.yearTableHead = tableHead;
  moFresh.yearTableList = tableList;
});

const initFreshList = action((categoryRes: any, cityRes: any, yearRes: any) => {
  const { type, tab } = moFresh;

  const tempType = localStorage.getItem('indicatorType6') || '';
  if (tempType && (tempType !== type)) moFresh.type = tempType;
  else localStorage.setItem('indicatorType6', type);

  const tempTab = localStorage.getItem('freshTab') || '';
  if (tempTab && (tempTab !== tab)) moFresh.tab = tempTab;
  else localStorage.setItem('freshTab', tab);

  initCategoryList(categoryRes);
  initCityList(cityRes);
  initYearList(yearRes);
});

const changeType = action((type: string) => {
  moFresh.type = type;
  localStorage.setItem('indicatorType6', type);
});

const changeTab = action((tab: string) => {
  moFresh.tab = tab;
  localStorage.setItem('freshTab', tab);
});

// 选择城市
const onChooseCity = action((code: number | string) => {
  // console.log('选择城市 -- ', code);
  const arr: any[] = cloneDeep(moFresh.cityArr);
  const chooseArr: any[] = cloneDeep(moFresh.chooseCity);
  arr.map((item: any) => {
    if (item.code === code) {
      chooseArr.push(item);
      item.active = true;
    }
  });
  moFresh.cityArr = arr;
  moFresh.chooseCity = chooseArr;
});

// 取消选择城市
const unChooseCity = action((code: number | string) => {
  // console.log('取消选择城市 -- ', code);
  const arr: any[] = cloneDeep(moFresh.cityArr);
  const chooseArr: any[] = cloneDeep(moFresh.chooseCity);
  for (let i = 0; i < chooseArr.length; i += 1) {
    if (chooseArr[i].code === code) chooseArr.splice(i, 1);
  }
  arr.map((item: any) => {
    if (item.code === code) item.active = false;
  });
  moFresh.cityArr = arr;
  moFresh.chooseCity = chooseArr;
});

// 选择/取消选择城市
const changeCity = action((code: number | string, name: string, active: boolean) => {
  if (!active) onChooseCity(code);
  else unChooseCity(code);
});

const onSure = action(() => {
  moFresh.isCity = false;
});

const toggleCityModal = action((value: boolean) => {
  if (value) {
    moFresh.backupCity = cloneDeep(moFresh.cityArr);
    moFresh.backupChoose = cloneDeep(moFresh.chooseCity);
  } else {
    moFresh.cityArr = cloneDeep(moFresh.backupCity);
    moFresh.chooseCity = cloneDeep(moFresh.backupChoose);
  }
  moFresh.isCity = value;
});

const initCityArr = action(async () => {
  const yearRes: any = await HRService.freshIndustryYear();
  let year: number | string = '';
  let tempYear: number | string = yearRes[yearRes.length - 1];

  if (!isEmpty(yearRes)) {
    let tempCategoryYear = localStorage.getItem('freshCategoryYear') || '';
    if (tempCategoryYear) {
      year = tempCategoryYear
    } else {
      year = tempYear;
      localStorage.setItem('freshCategoryYear', year.toString());
    }

    changeFreshCategoryYear(year);
  }
});

export default moFresh;
export {
  changeType, changeTab,
  changeCity, toggleCityModal, onSure,
  initCityList, initCategoryList, initYearList,
  initCityArr, initFreshList,
};
